import { MoneyWavy } from '@phosphor-icons/react';

export default MoneyWavy;
